import {DatePipe, UpperCasePipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {OphIconModule} from 'src/app/shared/design/oph-icon/oph-icon.module';
import {PipesModule} from 'src/app/shared/pipes/pipes.module';

@Component({
  selector: 'projects-task-date-time-button',
  standalone: true,
  imports: [OphIconModule, PipesModule, UpperCasePipe, DatePipe],
  templateUrl: './projects-task-date-time-button.component.html',
  styleUrl: './projects-task-date-time-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsTaskDateTimeButtonComponent {
  @Input() type: 'date' | 'time' = 'date';
  @Input() dateValue: string | null = null;
  @Input() isSelected: boolean = false;
  @Input() newTask: boolean = false;

  @Output() buttonClick = new EventEmitter<void>();

  today = new Date();

  get iconName(): string {
    return this.type === 'date' ? 'calendar-brown' : 'clock-brown';
  }

  get iconSize(): number {
    return this.type === 'date' ? 20 : 18;
  }

  get dateFormat(): string {
    return this.type === 'date' ? 'MMM d, yyyy' : 'h:mm a';
  }

  get dateFormatMoment(): string {
    return this.type === 'date' ? 'MMM D, yyyy' : 'h:mm a';
  }

  onButtonClick() {
    this.buttonClick.emit();
  }
}
